import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { FluxoFinanceiro } from "../api/dto/fluxo-financeiro";

@Injectable({
    providedIn: 'root',
})
export class FluxoFinanceiroService {

    constructor(private http: HttpClient){}

    private url : string = UrlServidor.URL_BASE + 'fluxos-financeiros';

    buscarPorId(id?: number): Observable<FluxoFinanceiro> {
        return this.http.get<FluxoFinanceiro>(`${this.url}/${id}`);
    }

    listarPorEmpresaId(id?: number): Observable<FluxoFinanceiro[]> {
        return this.http.get<FluxoFinanceiro[]>(`${this.url}/empresa/${id}`);
    }

    listarPorControle(controle?: number): Observable<FluxoFinanceiro[]> {
        return this.http.get<FluxoFinanceiro[]>(`${this.url}/controle/${controle}`);
    }


    listarPorEmpresaIdECodigoPlanoConta(id?: number, codigo?: number): Observable<FluxoFinanceiro[]> {
        return this.http.get<FluxoFinanceiro[]>(`${this.url}/empresa/${id}/plano-conta-empresa/${codigo}`);
    }

    salvar(fluxoFinanceiro?: FluxoFinanceiro): Observable<FluxoFinanceiro> {
        return this.http.post<FluxoFinanceiro>(this.url, fluxoFinanceiro);
    }

    atualizar(fluxoFinanceiro?: FluxoFinanceiro, id?: number): Observable<FluxoFinanceiro> {
        return this.http.put<FluxoFinanceiro>(`${this.url}/${id}`, fluxoFinanceiro);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`);
    }


}